export const scheduleHero = {
  title: '年間スケジュール',
  titleEn: 'ANNUAL SCHEDULE',
  lead: '各コースは年間スケジュールに沿って開校します。お申込みは開校の14日前まで承ります。',
};

export interface MonthEntry {
  month: number;
  label: string;
  course: 'essential' | 'advanced' | 'master' | 'break' | 'double';
  courseLabel: string;
  subLabel: string;
  description: string;
}

export const calendarMonths: MonthEntry[] = [
  { month: 1, label: '1月', course: 'essential', courseLabel: 'エッセンシャル', subLabel: 'ESSENTIAL', description: '基礎の所作と接遇の型を集中的に学ぶ入門コース' },
  { month: 2, label: '2月', course: 'master', courseLabel: 'マスター', subLabel: 'MASTER', description: '管理・危機対応・国際プロトコルまでを網羅する最上級コース' },
  { month: 3, label: '3月', course: 'master', courseLabel: 'マスター', subLabel: 'MASTER', description: '管理・危機対応・国際プロトコルまでを網羅する最上級コース' },
  { month: 4, label: '4月', course: 'master', courseLabel: 'マスター', subLabel: 'MASTER', description: '管理・危機対応・国際プロトコルまでを網羅する最上級コース' },
  { month: 5, label: '5月', course: 'advanced', courseLabel: 'アドバンス', subLabel: 'ADVANCED', description: 'ワインサービスやイベント運営など専門技能を磨く中級コース' },
  { month: 6, label: '6月', course: 'advanced', courseLabel: 'アドバンス', subLabel: 'ADVANCED', description: 'ワインサービスやイベント運営など専門技能を磨く中級コース' },
  { month: 7, label: '7月', course: 'essential', courseLabel: 'エッセンシャル', subLabel: 'ESSENTIAL', description: '基礎の所作と接遇の型を集中的に学ぶ入門コース' },
  { month: 8, label: '8月', course: 'break', courseLabel: '休校', subLabel: 'BREAK', description: '体験講座・法人研修に充当する期間です' },
  { month: 9, label: '9月', course: 'master', courseLabel: 'マスター', subLabel: 'MASTER', description: '管理・危機対応・国際プロトコルまでを網羅する最上級コース' },
  { month: 10, label: '10月', course: 'master', courseLabel: 'マスター', subLabel: 'MASTER', description: '管理・危機対応・国際プロトコルまでを網羅する最上級コース' },
  { month: 11, label: '11月', course: 'double', courseLabel: 'マスター／アドバンス', subLabel: 'MASTER & ADVANCED', description: 'マスターコース終盤とアドバンスコースが重なる開校月です' },
  { month: 12, label: '12月', course: 'advanced', courseLabel: 'アドバンス', subLabel: 'ADVANCED', description: 'ワインサービスやイベント運営など専門技能を磨く中級コース' },
];

export const yearEndEntry = {
  label: '年末年始',
  courseLabel: '休校',
  subLabel: 'YEAR-END BREAK',
  description: '年末年始は全コースを休講とします。新年1月よりエッセンシャルコースが開校します。',
};

export const courseDurationData = [
  {
    name: 'エッセンシャルコース',
    nameEn: 'ESSENTIAL',
    days: '8日間',
    hours: '48時間',
    weeks: '約1ヶ月',
    schedule: '7月・1月開校',
    href: '/courses/essential',
  },
  {
    name: 'アドバンスコース',
    nameEn: 'ADVANCED',
    days: '12日間',
    hours: '72時間',
    weeks: '約2ヶ月',
    schedule: '5〜6月・11〜12月開校',
    href: '/courses/advanced',
  },
  {
    name: 'マスターコース',
    nameEn: 'MASTER',
    days: '16日間',
    hours: '96時間',
    weeks: '約3ヶ月',
    schedule: '2〜4月・9〜11月開校',
    href: '/courses/master',
  },
];

export const commonInfoItems = [
  {
    icon: 'ri-calendar-check-line',
    text: 'すべての授業を土日に開催。1日6時間（90分×4コマ）の集中カリキュラムです。',
  },
  {
    icon: 'ri-user-line',
    text: '完全少人数制（定員6名）。最少催行人数は3名です。',
  },
  {
    icon: 'ri-timer-line',
    text: 'お申込み締切は各開校日の14日前。定員に達し次第、受付を締め切ります。',
  },
  {
    icon: 'ri-bank-line',
    text: 'お支払いは銀行振込による一括払いのみ。分割払い・クレジットカードはご利用いただけません。',
  },
];

export const scheduleFaqs = [
  {
    question: '各コースはいつ開校しますか？',
    answer:
      'マスターは2〜4月と9〜11月、アドバンスは5〜6月と11〜12月、エッセンシャルは7月と1月に開校予定です。8月と年末年始は休校です。',
  },
  {
    question: '申込の締切はいつですか？',
    answer:
      '各開校日の14日前までです。定員6名に達した時点で締め切ります。',
  },
  {
    question: '具体的な日程はどこで分かりますか？',
    answer:
      '開校日が決まり次第、お知らせページでご案内します。資料請求や個別相談でも最新の予定をお伝えできます。',
  },
];

export const scheduleRelatedPages = [
  {
    title: 'コース一覧・比較',
    description: '3コースの違いを一覧で確認',
    href: '/courses',
  },
  {
    title: 'エッセンシャルコース',
    description: '基礎から始める入門課程',
    href: '/courses/essential',
  },
  {
    title: 'アドバンスコース',
    description: '専門技能を磨く中級課程',
    href: '/courses/advanced',
  },
  {
    title: 'マスターコース',
    description: '管理・危機対応まで修める最上級課程',
    href: '/courses/master',
  },
  {
    title: '入学案内概要',
    description: '入学の流れと応募資格',
    href: '/admission',
  },
];